var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.162,
    height: 64.943,
    viewBox: "0 0 45.162 64.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fec12f;}.b{fill:#ffab01;}.c{fill:#163f59;}.d{fill:#f4da80;}.e{fill:#34688f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3505.238 -1061.294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3505.237 1061.294)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3460.08,1084.731c-.35-13.263-8.662-23.806-23.206-23.427s-22.289,11.343-21.937,24.608c.272,10.345,7.658,13.747,14.073,22.167,1.27,1.667.22,8.363.22,8.363l18.186-.475s-1.4-6.634-.221-8.363C-3467,1098.859-3459.806,1095.079-3460.08,1084.731Z",
    transform: "translate(3505.235 -1061.294)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3505.237 1072.285)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3483.456,1366.147c-8.864-11.636-19.071-16.336-19.448-30.635a41.8,41.8,0,0,1,.694-8.9,27.049,27.049,0,0,0-3.015,13.627c.272,10.346,7.658,13.748,14.072,22.168,1.27,1.667.221,8.363.221,8.363l8.341-.218C-3482.612,1368.689-3482.827,1366.971-3483.456,1366.147Z",
    transform: "translate(3505.237 -1326.612)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3491.244 1115.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-3167.435,2381.441l.066,2.494a7.51,7.51,0,0,0,7.722,7.291l3.762-.1a7.506,7.506,0,0,0,7.326-7.684l-.065-2.493Z",
    transform: "translate(3167.435 -2380.951)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3493.4 1078.989)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-3212.913,1495.65l-2.981-3.667-2.056,2.827-1.526-1.11,3.5-4.811,2.982,3.668,2.781-3.818,2.983,3.668,2.787-3.819,2.983,3.669,2.788-3.817,3.766,4.615-1.462,1.194-2.221-2.721-2.791,3.821-2.982-3.668-2.787,3.819-2.982-3.667Z",
    transform: "translate(3219.477 -1488.439)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3490.113 1087.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-3135.267,1726.23l-.41-15.548-4.442-12.116,1.772-.65,4.549,12.407.418,15.858Z",
    transform: "translate(3140.119 -1697.916)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3479.907 1087.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-2893.332,1718.639l-.419-15.859,3.888-12.627,1.8.556-3.8,12.331.411,15.549Z",
    transform: "translate(2893.751 -1690.153)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3486.089 1117.298)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-3031.193,2415.206l-11.756.306-.051-1.944,11.756-.306Z",
    transform: "translate(3043 -2413.261)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3485.998 1120.893)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-3032.272,2501.991l-8.464.221-.051-1.944,8.464-.221Z",
    transform: "translate(3040.787 -2500.046)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.d5991d29442e805dbb1390ba6c905bd5.svg";
export { ForwardRef as ReactComponent };